module.exports = "/_next/static/images/d8bf844401e1c4c80d3c81128b99513f-image-left-lg.jpg.webp";